import { Question } from './question.js';
import { arrowIconSvg, arrowIconUpSvg } from '../icons/icons.js';

export class MatrixQuestion extends Question {
    constructor(question, ctx) {
        super(question, ctx);
        this.matrixAnswers = Array.apply(null, { length: this.question.answers.length }).map(() => null);
    }

    renderContent() {
        this.ctx.elementIds.push('answerOptionsElement' + this.question.id);

        let questionAnswers = [];
        let temp = [...this.question.answers];
        questionAnswers = this.ctx.changeAnswerOptionsSequence(temp, this.question.randomType);

        let arrowIcon = arrowIconSvg(this.style.textColor);
        let arrowIconUp = arrowIconUpSvg(this.style.textColor);

        let matrixBlock = document.createElement('div');
        matrixBlock.style.marginTop = '16px';
        matrixBlock.classList.add('ph-matrix');
        matrixBlock.id = 'answerOptionsElement' + this.question.id;

        let matrixInternalContainer = document.createElement('div');
        matrixInternalContainer.classList.add('ph-matrix__container');
        this.matrixContainer = matrixInternalContainer;
        matrixBlock.appendChild(matrixInternalContainer);

        questionAnswers.forEach((answer, i) => {
            let matrixElement = document.createElement('div');
            matrixElement.classList.add('ph-matrix__row');
            matrixInternalContainer.appendChild(matrixElement);

            let dropbtn = document.createElement('div');
            dropbtn.id = 'dropbtn' + i + this.question.id;
            dropbtn.classList.add('ph-dropdown__btn');
            matrixElement.appendChild(dropbtn);

            let dropbtnContent = document.createElement('div');
            dropbtnContent.classList.add('ph-dropdown__content', 'ph-space-between');
            dropbtnContent.innerHTML = answer.content ? `${answer.content}<div>${arrowIcon}<div>` : `&nbsp<div>${arrowIcon}<div>`;
            dropbtnContent.id = 'dropbtnContent' + i + this.question.id;
            dropbtn.appendChild(dropbtnContent);

            let dropbtnAnswer = document.createElement('div');
            dropbtnAnswer.classList.add('ph-dropdown__answer');
            dropbtnAnswer.id = 'dropbtnAnswer' + i + this.question.id;
            dropbtn.appendChild(dropbtnAnswer);

            let dropdown = document.createElement('div');
            dropdown.classList.add('ph-dropdown__list');
            dropdown.setAttribute('role', 'radiogroup');
            dropdown.setAttribute('aria-label', answer.content || '');
            matrixElement.appendChild(dropdown);
            dropdown.style.width = '100%';
            dropdown.style.display = 'none';
            dropdown.id = 'dropdown' + i + this.question.id;
            matrixElement.appendChild(dropdown);

            dropbtn.setAttribute('role', 'button');
            dropbtn.setAttribute('tabindex', '0');
            dropbtn.setAttribute('aria-haspopup', 'listbox');
            dropbtn.setAttribute('aria-expanded', 'false');
            dropbtn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dropbtn.click();
                }
            });

            dropbtn.addEventListener('click', () => {
                let dropbtnContentEl = this.ctx.getById(this.shadowRoot, 'dropbtnContent' + i + this.question.id);

                let dropdowns = [];
                for (let j = 0; j < questionAnswers.length; j++) {
                    let dd = this.ctx.getById(this.shadowRoot, 'dropdown' + j + this.question.id);
                    dropdowns.push(dd);
                }
                dropdowns.forEach((dd, index) => {
                    if (index !== i) {
                        dd.style.display = 'none';
                        let dropbtnContentOther = this.ctx.getById(this.shadowRoot, 'dropbtnContent' + index + this.question.id);
                        dropbtnContentOther.innerHTML = `${questionAnswers[index].content || '&nbsp'}<div>${arrowIcon}<div>`;
                    }
                });
                dropdown.style.display === 'none' ? dropdown.style.display = 'flex' : dropdown.style.display = 'none';
                dropdown.style.display === 'none' ? dropbtnContentEl.innerHTML = `${answer.content || '&nbsp'}<div>${arrowIcon}<div>` : dropbtnContentEl.innerHTML = `${answer.content || '&nbsp'}<div>${arrowIconUp}<div>`;
                dropbtn.setAttribute('aria-expanded', dropdown.style.display !== 'none' ? 'true' : 'false');
            });

            this.question.evaluations.forEach((evaluation, index) => {
                let answerOption = document.createElement('div');
                let label = document.createElement('label');
                label.htmlFor = 'evaluation' + this.question.id + index + i;
                label.textContent = evaluation.content;
                answerOption.classList.add('ph-option');
                let input = document.createElement('input');
                input.type = 'radio';
                input.classList.add('ph-input--radio');
                input.id = 'evaluation' + this.question.id + index + i;
                input.name = 'evaluation' + this.question.id + i;
                input.value = evaluation.content;

                answerOption.appendChild(input);
                answerOption.appendChild(label);

                answerOption.addEventListener('click', (event) => {
                    if (event.target !== input && event.target !== label) {
                        input.checked = true;
                        input.dispatchEvent(new Event('click'));
                    }
                });

                input.addEventListener('click', () => {
                    input.checked ? this.matrixAnswers[i] = evaluation.content : this.matrixAnswers[i] = null;
                    if (!this.matrixAnswers.includes(null)) {
                        this.ctx.updateAnswers(this.question, this.matrixAnswers);
                    }

                    let dropbtnAnswerEl = this.ctx.getById(this.shadowRoot, 'dropbtnAnswer' + i + this.question.id);
                    let dropbtnContentEl = this.ctx.getById(this.shadowRoot, 'dropbtnContent' + i + this.question.id);

                    if (this.matrixAnswers[i]) {
                        dropdown.style.display = 'none';
                        dropbtnContentEl.innerHTML = `${answer.content}<div>${arrowIcon}<div>`;
                        dropbtn.setAttribute('aria-expanded', 'false');
                        dropbtnAnswerEl.textContent = this.matrixAnswers[i];
                    } else {
                        dropbtnAnswerEl.style.display = 'none';
                    }
                });
                dropdown.appendChild(answerOption);
            });
        });

        return matrixBlock;
    }

    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            const hasEmptyAnswer = this.matrixAnswers.some(answer => !answer);

            if (hasEmptyAnswer) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.matrixContainer);
            } else {
                this.clearAriaInvalid(this.matrixContainer);
                this.ctx.goNext(this.question, this.matrixAnswers);
            }
        });
        return nextButton;
    }
}
